import { Chip } from "@mui/material";

const ProductStatus = ({ status }) => {
  const statusToUpper = status ? status.toUpperCase() : null;

  if (!status) return null;
  return (
    <Chip
      label={statusToUpper}
      color={
        (statusToUpper === 'ACTIVE' && 'success') ||
        (statusToUpper === 'DRAFT' && 'warning') ||
        'default'
      }
      size="small"
      variant='outlined'
    />
  );
};

export default ProductStatus;